// extracted by mini-css-extract-plugin
export default {"assigneesList":"Assignees-module__assigneesList--aQ4Cj","assigneeNameLabel":"Assignees-module__assigneeNameLabel--YGqyR"};